import { type DraggerProps, type RcFile, type UploadChangeParam, type UploadFile } from "antd/es/upload"
import imageCompression from "browser-image-compression"

import promisify from "./promisify"

const handleImageChange = (info: UploadChangeParam<UploadFile>, max: number, setter: React.Dispatch<React.SetStateAction<UploadFile[]>>) => {
  let newFileList = [...info.fileList]

  newFileList = newFileList.slice(-max)

  setter(newFileList)
}

const uploadFile: DraggerProps["customRequest"] = (options) => {
  if (!(options.file as RcFile).name.match(/\.(png|jpeg|jpg)/g)) {
    return options.onError?.(new Error("Tipo inválido! São aceitos apenas arquivos png, jpg e jpeg!"))
  }

  promisify.dummy().then(() => {
    return options.onSuccess?.("ok")
  }).catch(err => options.onError?.(err))
}

const beforeUploadFile: DraggerProps["beforeUpload"] = async (file) => {
  const compressed = await imageCompression(file, {
    maxSizeMB: 1,
    maxWidthOrHeight: 650
  })
  return compressed
}

export default {
  handleImageChange,
  uploadFile,
  beforeUploadFile
}
